export default __webpack_public_path__ + "static/media/headerVideo2024.ced1968d.mp4";